import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { IconCheckmarkCircle , IconFire} from '../../components';

import css from './ListingPage.module.css';
import ListingAverageRating from '../../components/ListingAverageRating/ListingAverageRating';

const linkFormatted = (link) => {
  if (link?.indexOf("http://") === -1 && link?.indexOf("https://") === -1) {
    return `https://${link}`
  } else {
    return link
  }
}

const SectionHeading = props => {
  const {
    richTitle,
    currentListing,
    publicData,
    isOffer,
    currentUser,
    isOwnListing,
    isProviderVerified,
    sectionTotalReviews
  } = props;

  const websiteLink = publicData?.website;
  const customDisplayName = publicData?.customDisplayName;
  const isStartupOffer = publicData?.startupOfferTitle;

  return (
    <div className={css.sectionHeading}>
      <div className={css.heading}>
        <h1 className={css.title}>
          <span>
            {customDisplayName || richTitle}
          </span>
          {isProviderVerified && (
            <div className={css.verifiedBadge}>
              <IconCheckmarkCircle />
              <FormattedMessage id="ListingCard.verified" />
            </div>
          )}
          {isStartupOffer && (
            <div className={css.offerBadge}>
              <IconFire />
              <FormattedMessage id="ListingCard.offer" />
            </div>
          )}
        </h1>
        {!isOffer && (
          <ListingAverageRating
            listingId={currentListing?.id?.uuid}
            currentUser={currentUser}
            isOwnListing={isOwnListing} />
        )}

        <div className={css.author}>
          {websiteLink && <a href={linkFormatted(websiteLink)} target='_blank'>{websiteLink}</a>}
          {sectionTotalReviews}
          {/* {showContactUser ? (
            <span className={css.contactWrapper}>
              <InlineTextButton
                rootClassName={css.contactLink}
                onClick={onContactUser}
                enforcePagePreloadFor="SignupPage"
              >
                <FormattedMessage id="ListingPage.contactUser" />
              </InlineTextButton>
            </span>
          ) : null} */}
        </div>
      </div>
    </div>
  );
};

export default SectionHeading;
